import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setProgress, setToast } from "../../../redux/slice/system";
import { ContractAPI } from "../../../axios/api";
import {
  useAbortedEffect,
  useSearch,
  useTable,
} from "../../../components/hooks";

import ModuleBreadCrumb from "../../../components/breadCrumb";
import {
  formatOptions,
  setPageSetting,
  formatNumber,
} from "../../../service/common";
import { system_dropdown, system_table } from "../../../service/system";

import { Button } from "primereact/button";
import { classNames } from "primereact/utils";

export default function BackContractList() {
  const route_navigate = useNavigate();
  const dispatch = useDispatch();
  const crumbItem = [
    {
      key: 1,
      label: "提問管理",
    },
  ];
  const [reload, setReload] = useState({ list: false });
  const {
    setTbData,
    tbTotalRecords,
    setTbTotalRecords,
    setTbFirstIndex,
    setTbRows,
    setTbColumns,
    renderTable,
    setPageAction,
  } = useTable();
  // 篩選條件
  const defaultFilter = {
      page: 1,
      size: system_table.size,
      type: 1,
    },
    pagePath = "/contract";
  const {
    filterData,
    setFilterData,
    search,
    setSearch,
    changeFilter,
    renderSearchWrap,
  } = useSearch({
    defaultFilter,
    pagePath: [pagePath],
    tbSetting: { setTbFirstIndex, setTbRows },
    reloadAction: () => setReload((state) => ({ ...state, list: true })),
  });

  useEffect(() => {
    const action = ({ startIndex, rows }) => {
      let temp = {
        ...search,
        page: Math.floor(startIndex / rows) + 1,
        size: rows,
      };
      setFilterData(temp);
      setSearch(temp);
    };
    setPageAction(
      () =>
        ({ startIndex, rows }) =>
          action({ startIndex, rows })
    );
  }, [search]);

  // 取得列表資料
  useAbortedEffect(
    (signal) => {
      if (!reload.list) return;

      dispatch(setProgress(true));

      setPageSetting({ params: search, page: pagePath });

      let params = {
        ...search,
      };

      ContractAPI.getQuestionAndAnswerMemberList({
        data: params,
        options: { signal },
      }).then((result) => {
        let { Response, data, total, message } = result;

        if (Response === 1) {
          setTbData(data);
          setTbTotalRecords(total);
          setReload((state) => ({
            ...state,
            list: false,
          }));
        } else {
          dispatch(
            setToast({
              severity: "error",
              summary: message,
              detail: "",
            })
          );
        }

        dispatch(setProgress(false));
      });
    },
    [reload]
  );

  useEffect(() => {
    setTbColumns([
      {
        field: "member_name",
        header: "會員",
        className: "flex-grow-1 w-6rem white-space-prewrap",
      },
      {
        field: "createdatetime",
        header: "提問時間",
        className: "flex-grow-1 w-6rem white-space-prewrap",
      },
      {
        field: "question",
        header: "問題",
        className: "flex-grow-1 w-10rem white-space-prewrap",
      },
      {
        field: "answer",
        header: "回覆",
        className: "flex-grow-1 w-10rem white-space-prewrap",
      },
      {
        field: "target",
        header: "進階",
        className: "w-6rem",
        body: (data) => (
          <>
            <Button
              className="p-button-warning p-button-sm mr-2"
              type="button"
              label="編輯"
              onClick={() => route_navigate(`/back${pagePath}/${data.id}`)}
            />
          </>
        ),
      },
    ]);
  }, [pagePath]);

  return (
    <>
      <ModuleBreadCrumb crumbItem={crumbItem} />

      <h2 className="my-3 ml-1">提問管理</h2>

      <div className="border-round-lg bg-white p-3">
        {renderTable({
          className: "mt-2",
          options: { scrollable: true, scrollDirection: "both" },
        })}
      </div>
    </>
  );
}
